module.exports = __webpack_public_path__ + "static/img/hsfimg10.6c490c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/hsfimg10.jpg
// module id = kQ8A
// module chunks = 5